import React, { useEffect } from 'react'
import { Input, Checkbox, Select, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components/macro'
import { DateRangeFilter } from './DateRangeFilter'
import {
  fetchReceiptingOrders,
  setFilterDateBasis,
  setReceiptingExist,
} from '../../features/ReceiptingSlice'
import moment from 'moment/moment'
import { useDispatch, useSelector } from 'react-redux'

const ReceiptingFilter = ({
  venueId,
  isPoChecked,
  setIsPoChecked,
  isSupplierChecked,
  setIsSupplierChecked,
  searchQuery,
  setSearchQuery,
  isEmptySearch,
  setIsEmptySearch,
}) => {
  const dispatch = useDispatch()
  const dateFormat = 'DD/MM/YYYY'
  const filterDates = useSelector(state => state.receipting.filterDates)
  const filterDateBasis = useSelector(
    state => state.receipting.filterDateBasis || 'orderedDate',
  )

  const { Search } = Input

  useEffect(() => {
    setIsEmptySearch(false)
  }, [searchQuery])

  // Always refetch when visiting GR or changing venue/dates/date-basis so
  // Invoices attach/reconcile changes are not shown stale.
  useEffect(() => {
    if (!venueId) return
    dispatch(
      fetchReceiptingOrders(
        venueId,
        moment(filterDates.start).format(dateFormat),
        moment(filterDates.end).format(dateFormat),
      ),
    )
  }, [dispatch, filterDates, filterDateBasis, venueId])

  const handleCheckbox = () => {
    setIsPoChecked(!isPoChecked)
    setIsSupplierChecked(!isSupplierChecked)
  }

  const onSearch = () => {
    if (!searchQuery.trim()) {
      return setIsEmptySearch(true)
    }
  }

  const onDateBasisChange = value => {
    dispatch(setReceiptingExist(null))
    dispatch(
      setFilterDateBasis(
        value === 'actualDeliveryDate' ? 'actualDeliveryDate' : 'orderedDate',
      ),
    )
  }

  return (
    <Wrapper style={{ alignItems: 'center' }}>
      <DateBasisRow>
        {/* Ant Design v3 — use Select.Option children, not the v4 `options` prop */}
        <Select
          value={filterDateBasis}
          onChange={onDateBasisChange}
          style={{ minWidth: 220 }}
          dropdownMatchSelectWidth={false}
        >
          <Select.Option value='orderedDate'>
            Filter by Order Date
          </Select.Option>
          <Select.Option value='actualDeliveryDate'>
            Filter by Actual Delivery Date
          </Select.Option>
        </Select>
        <Tooltip
          title={
            filterDateBasis === 'actualDeliveryDate'
              ? 'Shows orders whose goods physically arrived in this range (not when the PO was placed). Receipts without a recorded delivery date are excluded.'
              : 'Shows orders by when the purchase order was placed (existing Goods Receipting behaviour).'
          }
        >
          <InfoCircleOutlined
            style={{ color: '#8c8c8c', cursor: 'help', marginLeft: 6 }}
          />
        </Tooltip>
      </DateBasisRow>

      <DateRangeFilter />

      <div style={inputContainer}>
        <Search
          size='large'
          placeholder='Search by'
          style={{ width: 300, margin: '0 5px 0 10px' }}
          type='text'
          value={searchQuery}
          allowClear
          onPressEnter={onSearch}
          onChange={e => {
            setSearchQuery(e.target.value.toLowerCase())
          }}
        />
        {isEmptySearch && <SearchError>Please enter a search term</SearchError>}
      </div>

      <div style={{ margin: '0 10px' }}>
        <Checkbox checked={isSupplierChecked} onChange={handleCheckbox}>
          Supplier
        </Checkbox>
        <Checkbox checked={isPoChecked} onChange={handleCheckbox}>
          PON
        </Checkbox>
      </div>
    </Wrapper>
  )
}

const inputContainer = {
  display: 'flex',
  position: 'relative',
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 8px;
`
const DateBasisRow = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-width: 220px;
`
const SearchError = styled.p`
  color: #ff4d4f;
  position: absolute;
  bottom: 100%;
  padding: 0;
  margin: 0;
  left: 10px;
`
export default ReceiptingFilter
